const docMissingCompanyStatus = {
  text: 'COMPANY MANUALLY BLOCKED'
};

export default docMissingCompanyStatus;
